import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "@hooks/redux";
import {
  updateFocusType,
  updateVideoType,
  updateProductType,
  updateCharacterType,
  FocusType,
  VideoType,
  ProductType,
  CharacterType,
  FocusTypeEnum,
} from "../librarySlice";

export function useLibraryFilters() {
  const dispatch = useAppDispatch();
  const { focusType, videoType, productType, characterType } = useAppSelector((state) => state.libraryReducer);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const type = searchParams.get("type") as FocusType | null;
    if (type) dispatch(updateFocusType(type));
    const vt = searchParams.get("videoType") as VideoType | null;
    if (vt) dispatch(updateVideoType(vt));
    const pt = searchParams.get("productType") as ProductType | null;
    if (pt) dispatch(updateProductType(pt));
    const ct = searchParams.get("characterType") as CharacterType | null;
    if (ct) dispatch(updateCharacterType(ct));
  }, [searchParams, dispatch]);

  const syncUrl = (
    patch: Partial<{
      focusType: FocusType;
      videoType: VideoType;
      productType: ProductType;
      characterType: CharacterType;
    }>,
  ) => {
    const next = new URLSearchParams(searchParams);
    const ft = patch.focusType ?? focusType;
    next.set("type", ft);
    if (ft === FocusTypeEnum.Video) next.set("videoType", patch.videoType ?? videoType);
    else next.delete("videoType");
    if (ft === FocusTypeEnum.Product) next.set("productType", patch.productType ?? productType);
    else next.delete("productType");
    if (ft === FocusTypeEnum.Character) next.set("characterType", patch.characterType ?? characterType);
    else next.delete("characterType");
    setSearchParams(next, { replace: true });
  };

  return {
    focusType,
    videoType,
    productType,
    characterType,
    setFocusType: (value: FocusType) => {
      dispatch(updateFocusType(value));
      syncUrl({ focusType: value });
    },
    setVideoType: (value: VideoType) => {
      dispatch(updateVideoType(value));
      syncUrl({ videoType: value });
    },
    setProductType: (value: ProductType) => {
      dispatch(updateProductType(value));
      syncUrl({ productType: value });
    },
    setCharacterType: (value: CharacterType) => {
      dispatch(updateCharacterType(value));
      syncUrl({ characterType: value });
    },
  };
}
